export default "__VITE_ASSET__CklT_LoI__"